import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { headerNotifications } from "../../constants/actionTypes";
import {
  setUserNotificationListData,
  setUserNotificationListError,
  userNotificationReadStatusSuccess,
  userNotificationReadStatusError,
} from "../actions/headerNotification";
import { fetchUserNotificationList, userNotificationUpdateReadStatus } from "../api/headerNotification";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { toasterFlags } from "../../constants/componentConstants";

export function* fetchUserNotificationListFunction({ payload }) {
  try {
    const data = yield call(fetchUserNotificationList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setUserNotificationListData(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.Failure);
      yield put(setUserNotificationListError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.Failure);
    yield put(setUserNotificationListError(err));
  }
}

export function* userNotificationReadStatusFunction({ payload }) {
  try {
    const data = yield call(userNotificationUpdateReadStatus, payload);
    if (data?.status === statusCode?.Ok200) {
      yield put(userNotificationReadStatusSuccess({ data }));
    } else {
      toastNotification(toasterFlags.WARN, data?.Failure);
      yield put(userNotificationReadStatusError(data));
    }
  } catch (err) {
    yield put(userNotificationReadStatusError(err));
  }
}

export function* headerNotificationRootSaga() {
  yield takeLatest(headerNotifications.USER_NOTIFICATION_LIST_GET_DATA, fetchUserNotificationListFunction);
  yield takeLatest(headerNotifications.USER_NOTIFICATION_UPDATE_READ_STATUS, userNotificationReadStatusFunction);
}

export default function* rootSaga() {
  yield all([fork(headerNotificationRootSaga)]);
}
